module.exports = __webpack_public_path__ + "static/img/pro3_tab1.68e0f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab1.jpg
// module id = ippk
// module chunks = 171